import Header from "../components/header";

import { useSelector } from 'react-redux'
import HeaderSection from "../components/header-section";
import FilterBox from "../components/prenotationfilterBox";
import PrenotationTable from "../components/prenotationTable";

import React from "react";
import { hasModules } from "../utils/helpers";

const Prenotations = () => {
  const { namePharmacy, eventHash } = useSelector((state: any) => state.login);
  const { user } = useSelector((state: any) => state.login);

  const headerTitle = hasModules(user,'FEDERFARMA_DOCTOR') ? [user?.name,user?.surname].join(" ")  : namePharmacy
  return (
    <>
      <Header titleLogOut={user?.name} />

      <HeaderSection visibleButton={true} titleSection={headerTitle} eventHash={eventHash} />
      <FilterBox />
      <PrenotationTable />
    </>
  );
}

export default Prenotations;
